import React from "react";
//sayani Changes new file
const FilterDropdownIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.875 5C1.875 4.65482 2.15482 4.375 2.5 4.375H17.5C17.8452 4.375 18.125 4.65482 18.125 5C18.125 5.34518 17.8452 5.625 17.5 5.625H2.5C2.15482 5.625 1.875 5.34518 1.875 5Z"
        fill="#A4A3B1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.20833 10C5.20833 9.65482 5.48816 9.375 5.83333 9.375L14.1667 9.375C14.5118 9.375 14.7917 9.65482 14.7917 10C14.7917 10.3452 14.5118 10.625 14.1667 10.625L5.83333 10.625C5.48816 10.625 5.20833 10.3452 5.20833 10Z"
        fill="#A4A3B1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.54167 15C8.54167 14.6548 8.82149 14.375 9.16667 14.375L10.8333 14.375C11.1785 14.375 11.4583 14.6548 11.4583 15C11.4583 15.3452 11.1785 15.625 10.8333 15.625L9.16667 15.625C8.82149 15.625 8.54167 15.3452 8.54167 15Z"
        fill="#A4A3B1"
      />
    </svg>
  );
};

export default FilterDropdownIcon;
